import React from "react"
import { HomeNewsWrapper } from "./HomeNews.styles"
import ArrowRight from "../../../icons/phosphor/regular/ArrowRight"
import { graphql, useStaticQuery } from "gatsby"
import { prefixStatamicAssetUrl } from "../../../utils/statamicAssets"

/**
 * @returns {{ id: string, slug: string, title: string, category: { name: string }[], externalLink: string | null, previewImage: { fluid: { src: string } | null, title: string } | null }[]}
 */
function useNews(){
  const data = useStaticQuery(graphql`
    query HomeNewsQuery {
      statamic {
        entries(
          collection: "blog_posts"
          limit: 4
          sort: "published_on desc"
          filter: { featured: { equals: true } }
        ) {
          data {
            id
            slug
            title
            ... on Statamic_Entry_BlogPosts_BlogPost {
              external_link
              blog_categories {
                slug
                title
              }
              preview_image {
                url
                permalink
                ... on Statamic_Asset_Assets {
                  alt
                }
              }
            }
          }
        }
      }
    }
  `)

  const entries = data?.statamic?.entries?.data || []
  return entries.map(entry => {
    const previewSrc = entry.preview_image && (entry.preview_image.permalink || entry.preview_image.url)
    return {
      id: entry.id,
      slug: entry.slug,
      title: entry.title,
      category: (entry.blog_categories || []).map(c => ({ name: c.title })),
      externalLink: entry.external_link || null,
      previewImage: previewSrc ? {
        fluid: { src: prefixStatamicAssetUrl(previewSrc) },
        title: (entry.preview_image && entry.preview_image.alt) || entry.title,
      } : null,
    }
  });
}

export default function(){

  const articles = useNews();

  return (
      <HomeNewsWrapper className="px-3">
        <div className="container">

          <div className="intro">
            <h2>Latest news</h2>
            <a href="/press-and-media">
              All updates
              <ArrowRight />
            </a>
          </div>

          <div className="articles">

            {articles.map((article, index) => (
                <article key={index}>
                  <div className="image">
                    {article.previewImage && article.previewImage.fluid &&
                        <img src={article.previewImage.fluid.src} alt={article.previewImage.title} />}
                  </div>
                  <div className="content">
                    {article.category?.length && <div className="category">{article.category[0].name}</div>}
                    <h3>
                      <a href={article.externalLink || `/blog/${article.slug}`}>
                        {article.title}
                      </a>
                    </h3>
                  </div>
                  <div className="circles top" role="presentation" aria-hidden="true">
                    <div className="circle"></div>
                    <div className="circle"></div>
                    <div className="circle"></div>
                    <div className="circle"></div>
                    <div className="circle"></div>
                    <div className="circle"></div>
                  </div>
                  <div className="circles bottom" role="presentation" aria-hidden="true">
                    <div className="circle"></div>
                    <div className="circle"></div>
                    <div className="circle"></div>
                    <div className="circle"></div>
                  </div>
                </article>
            ))}

          </div>

        </div>
      </HomeNewsWrapper>
  )
}
